<template>
    <div>
        <Head :title="'訂單 #' + order.order_no" />

        <div class="my-10 text-xl text-bold text-center">訂單明細</div>

        <div class="my-10">
            <div class="info-item">
                <label>收件人資訊</label>
                <div class="info-subitem">
                    <div class="column">
                        <label>姓名</label>
                        {{ order.recipient.name }}
                    </div>
                    <div class="column">
                        <label>電話</label>
                        {{ order.recipient.phone }}
                    </div>
                    <template
                        v-if="
                            order.recipient.delivery_method == '711' ||
                            order.recipient.delivery_method == '711_pay'
                        "
                    >
                        <div class="column">
                            <label>取件門市</label>
                            {{ order.recipient.storename }}
                        </div>
                        <div class="column">
                            <label>取件門市地址</label>
                            {{ order.recipient.storeaddress }}
                        </div>
                    </template>
                    <template v-else>
                        <div class="column">
                            <label>收件地址</label>
                            {{ order.recipient.address }}
                        </div>
                        <div class="column">
                            <label>收貨時間</label>
                            {{ order.recipient.time }}
                        </div>
                    </template>
                </div>
            </div>

            <div class="info-item" v-if="order.recipient.delivery">
                <label>送貨資訊</label>
                <div class="info-subitem">
                    <div class="column">
                        <label>運費</label>
                        <span
                            :class="{
                                crossed:
                                    order.shipping_per_type[
                                        delivery_type + '_free-shipping'
                                    ],
                            }"
                            :key="delivery_type + '_shipping'"
                            v-for="delivery_type in existing_delivery_types"
                        >
                            {{
                                order.shipping_per_type[delivery_type]
                                    | commaFormat
                                    | priceFormat
                            }}
                        </span>
                    </div>
                    <div class="column">
                        <label>送貨方式</label>
                        <span
                            :key="delivery_type + '_shipping'"
                            v-for="delivery_type in existing_delivery_types"
                        >
                            {{ delivery_types[delivery_type] }}
                        </span>
                    </div>
                    <div v-if="order.recipient.delivery_status" class="column">
                        <label>物流狀態</label>
                        <span
                            :key="delivery_type + '_delivery_status'"
                            v-for="delivery_type in existing_delivery_types"
                        >
                            <template
                                v-if="
                                    order.recipient.delivery_status[
                                        delivery_type
                                    ]
                                "
                            >
                                <!-- [{{
                    order.recipient.delivery_status[delivery_type].StationName
                  }}] -->
                                {{
                                    order.recipient.delivery_status[
                                        delivery_type
                                    ].StatusName
                                }}
                            </template>
                        </span>
                    </div>

                    <div class="column">
                        <label
                            ><template
                                v-if="
                                    order.recipient.delivery_method == '711' ||
                                    order.recipient.delivery_method == '711_pay'
                                "
                            >
                                取件代碼
                            </template>
                            <template v-else> 物流追蹤碼 </template></label
                        >
                        <span
                            :key="delivery_type + '_shipping'"
                            v-for="delivery_type in existing_delivery_types"
                        >
                            <template
                                v-if="order.recipient.delivery[delivery_type]"
                            >
                                <template
                                    v-if="
                                        order.recipient.delivery_method ==
                                            '711' ||
                                        order.recipient.delivery_method ==
                                            '711_pay'
                                    "
                                >
                                    <a
                                        :href="
                                            'https://eservice.7-11.com.tw/e-tracking/search.aspx?__EVENTTARGET=&txtProductNum=' +
                                            order.recipient.delivery[
                                                delivery_type
                                            ]
                                        "
                                        target="_blank"
                                        >{{
                                            order.recipient.delivery[
                                                delivery_type
                                            ]
                                        }}</a
                                    >
                                </template>
                                <template v-else>
                                    <a
                                        :href="
                                            'https://www.t-cat.com.tw/Inquire/TraceDetail.aspx?BillID=' +
                                            order.recipient.delivery[
                                                delivery_type
                                            ]
                                        "
                                        target="_blank"
                                        >{{
                                            order.recipient.delivery[
                                                delivery_type
                                            ].replace(
                                                /(\d{4})(\d{4})(\d{4})/,
                                                "$1-$2-$3"
                                            )
                                        }}</a
                                    >
                                </template>
                            </template>
                        </span>
                    </div>
                </div>
            </div>

            <div
                class="info-item"
                :key="delivery_type + '_delivery'"
                v-for="delivery_type in existing_delivery_types"
            >
                <div class="table-header">
                    訂購明細 - {{ delivery_types[delivery_type] }}
                </div>
                <DataTable
                    :ref="'datatable_' + delivery_type"
                    :value="
                        $page.props.order.items_raw[delivery_type].filter(
                            (product) => product.type != 'add-on'
                        )
                    "
                    :expandedRows.sync="
                        expended_products_by_type[delivery_type]
                    "
                >
                    <Column headerClass="w-11">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.type == 'add-on'">
                                加購
                            </div>
                        </template>
                    </Column>

                    <Column
                        :ref="delivery_type + '_product_column'"
                        header="商品"
                    >
                        <template #body="slotProps">
                            <div
                                class="flex justify-start items-center gap-x-4 max-w-full"
                            >
                                <!-- @click="goToProductPage(slotProps.data.slug)" -->
                                <img
                                    v-if="
                                        Array.isArray(slotProps.data.images) &&
                                        slotProps.data.images.length > 0
                                    "
                                    class="object-cover aspect-square product-image"
                                    :src="
                                        '/storage/product-images/' +
                                        slotProps.data.images[0] +
                                        '/100.jpg'
                                    "
                                />
                                <img
                                    v-else
                                    class="object-cover aspect-square product-image"
                                    src="//dummyimage.com/100/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                                />
                                <div class="">
                                    {{ slotProps.data.name }}
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column headerClass="w-40" header="價格">
                        <template #body="slotProps">
                            <div
                                class="flex flex-col justify-start items-start gap-y-1"
                            >
                                <div>
                                    <span
                                        :class="{
                                            'line-through':
                                                slotProps.data.settings.on_sale,
                                        }"
                                        >{{
                                            slotProps.data.settings.discount
                                                .original_price
                                                | commaFormat
                                                | priceFormat
                                        }}</span
                                    >
                                    <span
                                        v-if="slotProps.data.settings.on_sale"
                                        class="text-red ml-1"
                                        >{{
                                            slotProps.data.unit_price
                                                | commaFormat
                                                | priceFormat
                                        }}</span
                                    >
                                </div>
                                <!-- <div>
                  CV:
                  <span
                    :class="{
                      'line-through': slotProps.data.settings.on_sale,
                    }"
                    >{{
                      slotProps.data.settings.discount.original_cv | commaFormat
                    }}</span
                  >
                  <span
                    v-if="slotProps.data.settings.on_sale"
                    class="text-red ml-1"
                    >{{ slotProps.data.unit_cv | commaFormat }}</span
                  >
                </div> -->
                                <div
                                    v-if="
                                        slotProps.data.settings.on_sale &&
                                        slotProps.data.settings.on_sale.enabled
                                    "
                                    class="text-red text-xs"
                                >
                                    {{ slotProps.data.settings.on_sale.name }}
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column headerClass="w-20" header="數量">
                        <template #body="slotProps">
                            <div
                                class="flex flex-col justify-between items-center"
                            >
                                <div>
                                    {{ slotProps.data.quantity }}
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column headerClass="w-40" header="總計">
                        <template #body="slotProps">
                            <div
                                class="flex flex-col justify-start items-start gap-y-1"
                            >
                                <div
                                    :class="{
                                        'text-red':
                                            slotProps.data.settings.on_sale,
                                    }"
                                >
                                    {{
                                        (slotProps.data.unit_price *
                                            slotProps.data.quantity)
                                            | commaFormat
                                            | priceFormat
                                    }}
                                </div>
                                <!-- <div
                  :class="{
                    'text-red': slotProps.data.settings.on_sale,
                  }"
                >
                  CV:
                  {{
                    (slotProps.data.unit_cv * slotProps.data.quantity)
                      | commaFormat
                  }}
                </div> -->
                            </div>
                        </template>
                    </Column>

                    <template #footer>
                        <div
                            class="mt-0 mb-3"
                            v-if="
                                hasAddOn($page.props.order.items[delivery_type])
                            "
                        >
                            <DataTable
                                responsiveLayout="scroll"
                                :value="
                                    $page.props.order.items_raw[
                                        delivery_type
                                    ].filter(
                                        (product) => product.type == 'add-on'
                                    )
                                "
                            >
                                <Column headerClass="w-11"
                                    ><template #body="slotProps">
                                        <div
                                            v-if="
                                                slotProps.data.type == 'add-on'
                                            "
                                        >
                                            加購
                                        </div>
                                    </template></Column
                                >
                                <Column
                                    ><template #body="slotProps">
                                        <div
                                            class="flex justify-start items-center gap-x-4"
                                            @click="
                                                goToProductPage(
                                                    slotProps.data.slug
                                                )
                                            "
                                        >
                                            <img
                                                src="//dummyimage.com/100"
                                                class="product-image"
                                            />
                                            <div class="">
                                                {{ slotProps.data.id }}
                                                {{ slotProps.data.name }}
                                            </div>
                                        </div>
                                    </template></Column
                                >
                                <Column headerClass="w-40"
                                    ><template #body="slotProps">
                                        <div
                                            class="flex flex-col justify-start items-start gap-y-1"
                                        >
                                            <div>
                                                {{
                                                    slotProps.data.unit_price
                                                        | commaFormat
                                                        | priceFormat
                                                }}
                                            </div>
                                            <!-- <div>CV: {{ slotProps.data.unit_cv | commaFormat }}</div> -->
                                        </div>
                                    </template></Column
                                >
                                <Column headerClass="w-20"
                                    ><template #body="slotProps">
                                        <div
                                            class="flex flex-col justify-between items-center"
                                        >
                                            <div>
                                                {{ slotProps.data.quantity }}
                                            </div>
                                        </div>
                                    </template></Column
                                >
                                <Column headerClass="w-40"
                                    ><template #body="slotProps">
                                        <div
                                            class="flex flex-col justify-start items-start gap-y-1"
                                        >
                                            <div>
                                                {{
                                                    slotProps.data.total_price
                                                        | commaFormat
                                                        | priceFormat
                                                }}
                                            </div>
                                            <!-- <div>CV: {{ slotProps.data.total_cv | commaFormat }}</div> -->
                                        </div>
                                    </template></Column
                                >
                            </DataTable>
                        </div>

                        <div class="flex justify-end items-center gap-16">
                            <span
                                class="text-red"
                                v-if="
                                    $page.props.order.shipping_per_type[
                                        delivery_type + '_applied_rule'
                                    ]
                                "
                            >
                                {{
                                    $page.props.order.shipping_per_type[
                                        delivery_type + "_applied_rule"
                                    ].description
                                }}
                            </span>
                            <span>
                                運費
                                {{
                                    $page.props.order.shipping_per_type[
                                        delivery_type
                                    ] +
                                    ($page.props.order.shipping_per_type[
                                        delivery_type + "_free-shipping"
                                    ] ?? 0)
                                }}</span
                            >
                            <span>
                                總計
                                {{
                                    $page.props.order.price_per_type[
                                        delivery_type
                                    ]
                                        | commaFormat
                                        | priceFormat
                                }}
                            </span>
                            <!-- <span>
                CV
                {{ $page.props.order.cv_per_type[delivery_type] | commaFormat }}
              </span> -->
                        </div>
                    </template>
                </DataTable>
            </div>

            <div class="info-item" v-if="order.discount > 0">
                <label>訂單折扣</label>
                <div class="info-subitem">
                    <div class="column">
                        <label>名稱</label>
                        <span
                            :key="'discount1' + index"
                            v-for="(discount, index) in order.applied_discounts"
                        >
                            {{ discount.description }}
                        </span>
                    </div>

                    <div class="column">
                        <label>金額</label>
                        <span
                            :key="'discount2' + index"
                            v-for="(discount, index) in order.applied_discounts"
                        >
                            {{ discount.amount | commaFormat | priceFormat }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="info-item">
                <label>訂單資訊</label>
                <div class="info-subitem">
                    <div class="column">
                        <label>訂單號碼</label>
                        {{ order.order_no }}
                    </div>
                    <div class="column">
                        <label>訂單日期</label>
                        {{ formatDate(order.created_at) }}
                    </div>
                    <div class="column">
                        <label>總計金額</label>
                        {{ order.total_price | commaFormat | priceFormat }}
                    </div>
                    <!-- <div class="column">
            <label>總計CV</label>
            {{ order.cv }}
          </div> -->
                    <!-- <div class="column">
            <label>購物金抵用</label>
            {{ order.bonus }}
          </div> -->
                    <div class="column">
                        <label>訂單狀態</label>
                        {{ statusString(order.status) }}
                    </div>
                </div>
            </div>

            <div v-if="order.status == 0" class="flex justify-between">
                <Button label="取消訂單" @click="cancelOrder" />
                <Button label="前往付款" @click="proceedPayment" />
            </div>

            <!-- <div v-if="order.status == 1" class="flex justify-between">
          <Button label="取消訂單" @click="cancelOrder" />
          <span />
        </div> -->

            <div
                v-if="order.status == 1 || order.status == 6"
                class="flex justify-between"
            >
                <Button label="申請退款" @click="requestRefund" />
            </div>

            <!-- <div v-if="order.status == -1" class="flex justify-between">
          <Button label="取消訂單" @click="cancelOrder" />
        </div> -->
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import OrderList from "./OrderList";
import OrderTemplate from "../User/Shared/OrderTemplate";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";

export default {
    layout: Layout,
    components: {
        OrderList,
        OrderTemplate,
        DataTable,
        Column,
        Button,
    },
    props: { order: Object },
    filters: {
        priceFormat: function (value) {
            return "$" + value;
        },
        commaFormat: function (value) {
            return value
                .toString()
                .replace(
                    /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
                    function (all, pre, groupOf3Digital) {
                        return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
                    }
                );
        },
    },
    data() {
        return {
            delivery_types: {
                normal: "一般商品",
                refrigerated: "冷藏商品",
                frozen: "冷凍商品",
            },
            expended_products_by_type: {
                normal: [],
                refrigerated: [],
                frozen: [],
            },
        };
    },
    computed: {
        existing_delivery_types() {
            return _.keys(this.$page.props.order.items);
        },
    },
    methods: {
        cancelOrder() {
            this.$confirm.require({
                message: "請確認是否取消訂單。",
                header: "確認取消訂單",
                acceptLabel: "取消訂單",
                rejectLabel: "不要取消訂單",
                accept: () => {
                    this.$inertia.post(
                        route("guest.orders.order", this.order.order_no),
                        {
                            action: "cancelOrder",
                        }
                    );
                },
                reject: () => {
                    //
                },
            });
        },
        requestRefund() {
            this.$confirm.require({
                message: "請確認是否申請退款。",
                header: "確認申請退款",
                acceptLabel: "申請退款",
                rejectLabel: "不要申請退款",
                accept: () => {
                    this.$inertia.post(
                        route("guest.orders.order", this.order.order_no),
                        {
                            action: "requestRefund",
                        }
                    );
                },
                reject: () => {
                    //
                },
            });
        },
        proceedPayment() {
            window.location = route("payment.proceed", this.order.order_no);
        },
        hasAddOn(products) {
            return (
                _.findIndex(products, {
                    type: "add-on",
                }) >= 0
            );
        },
        formatDate(dateString) {
            let date = new Date(dateString);
            return (
                date.getFullYear() +
                "/" +
                (date.getMonth() + 1).toString().padStart(2, "0") +
                "/" +
                date.getDate().toString().padStart(2, "0")
            );
        },
        statusString(statusCode) {
            return this.$page.props.status_strings[statusCode];
        },
    },
};
</script>

<style lang="postcss">
.info-item {
    @apply mb-5 p-2 border border-fh-gray-border;
}

.info-subitem {
    @apply mt-2 py-2 flex justify-start flex-wrap gap-8;
}

.info-subitem .column {
    @apply flex flex-col;
}

.info-subitem .column label {
    @apply text-xs;
}

.crossed {
    @apply text-red line-through;
}
</style>
